import React from 'react'

import { useBotId } from '../../../../../../store/flow'
import { useLoadedBotApiUrl } from '../../../../../../store/app'
import { Button, ButtonType } from '../../../../../Styleguide/Button'
import { CopyTelephoneNumberButton, FuzzyQuestionAnswerLogsDownloadButton } from './components'

export const TelephonyControlWidget: React.FC = () => {
  const botId = useBotId()
  const apiUrl = useLoadedBotApiUrl()

  if (!botId || !apiUrl) {
    return (
      <span style={{ width: 'calc(80% - 26px)' }}>
        Launch hosting first to enable telephony controls
      </span>
    )
  }

  const callsListUrl = `/bots/${botId}/calls?fullscreen`

  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      <Button
        text="Open calls list"
        buttonType={ButtonType.DEFAULT}
        onClick={e => {
          e.preventDefault()
          window.open(callsListUrl)
        }}
      />
      <FuzzyQuestionAnswerLogsDownloadButton />
      <CopyTelephoneNumberButton />
    </span>
  )
}
